var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0938 0.90625C15.3438 0.65625 15.75 0.84375 15.75 1.15625V5.625C15.75 5.84375 15.5625 6 15.375 6H10.875C10.5625 6 10.375 5.625 10.625 5.375L12.3125 3.6875C11.2188 2.5625 9.6875 1.875 8 1.875C4.71875 1.875 2.0625 4.4375 1.875 7.65625C1.84375 7.875 1.6875 8 1.5 8H0.625C0.40625 8 0.21875 7.84375 0.25 7.625C0.4375 3.53125 3.84375 0.25 8 0.25C10.125 0.25 12.0625 1.125 13.4688 2.53125L15.0938 0.90625ZM15.3438 8C15.5625 8 15.75 8.1875 15.7188 8.40625C15.5312 12.5 12.125 15.75 8 15.75C5.84375 15.75 3.90625 14.9062 2.5 13.5L0.875 15.125C0.625 15.375 0.25 15.1875 0.25 14.875V10.375C0.25 10.1875 0.40625 10 0.625 10H5.09375C5.40625 10 5.59375 10.4062 5.34375 10.6562L3.65625 12.3438C4.75 13.4688 6.28125 14.125 8 14.125C11.25 14.125 13.9062 11.5938 14.0938 8.375C14.125 8.15625 14.2812 8 14.4688 8H15.3438Z",
    fill: "#C5C5C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.bbba889cfa1e09cde850a31be0cc8d4c.svg";
export { ForwardRef as ReactComponent };